
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my_communities",
      function () {
        return require("private-next-pages/my_communities.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my_communities"])
      });
    }
  